import { Inject } from '@odinjs/odin';

import { catchRenderException, EQUALS, equalsValidator } from '@philips-emr/hpms-components';
import { ButtonAPI, FieldAPI, FormAPI, PanelAPI } from '@philips-emr/tws-components';
import Controller, { OnClick, OnClose, OnMount, OnValidate } from '@philips-emr/tws-core/lib/client';
import { MountEvent, ValidateEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import { FragmentNames, ModalNovaSenhaAliases, RootRoutes } from '../../codegen';
import { Endpoints } from '../../definitions/endpoints';
import { ToastService } from '../../services';
import BaseController from '../base/base-controller';

@Controller({ fragment: FragmentNames.MODAL_NOVA_SENHA })
export default class ModalNovaSenhaController extends BaseController {

  @Inject(ModalNovaSenhaAliases.PANEL_FORM)
  private panelForm: PanelAPI;
  @Inject(ModalNovaSenhaAliases.PANEL_LOADER)
  private panelLoader: PanelAPI;
  @Inject(ModalNovaSenhaAliases.PANEL_AVISO_FALHA)
  private panelAvisoFalha: PanelAPI;
  @Inject(ModalNovaSenhaAliases.PANEL_AVISO_SUCESSO)
  private panelAvisoSucesso: PanelAPI;
  @Inject(ModalNovaSenhaAliases.FORM)
  private form: FormAPI;
  @Inject(ModalNovaSenhaAliases.BUTTON_CONFIRMAR)
  private buttonConfirmar: ButtonAPI;

  @OnClose(ModalNovaSenhaAliases.MODAL_NOVA_SENHA)
  onClose = (): void => this.historyService.push(RootRoutes.ROUTE_LOGIN);

  @OnValidate(ModalNovaSenhaAliases.FORM)
  onValidate = ({ valid }: ValidateEvent): void => this.buttonConfirmar.setEnabled(valid);

  @OnMount(ModalNovaSenhaAliases.MODAL_NOVA_SENHA)
  onMount(): void {
    const { hash } = this.historyService.getCurrentRouteParams();

    HttpService.get(Endpoints.POST.NOVA_SENHA, { hash })
      .then(() => this.panelForm.setVisible(true))
      .catch(() => this.panelAvisoFalha.setVisible(true))
      .finally(() => catchRenderException(() => this.panelLoader.setVisible(false)));
  }

  @OnMount(ModalNovaSenhaAliases.FIELD_CONFIRMAR)
  onMountField({ target }: MountEvent): void {
    const api = target as FieldAPI;
    api.addLocalValidator(EQUALS, (value) => {
      const { newPassword } = this.form.getRecord();
      return equalsValidator(value as string, newPassword as string);
    });
  }

  @OnClick(ModalNovaSenhaAliases.BUTTON_CONFIRMAR)
  onClick(): void {
    this.form.submit();
    if (this.form.isValid()) {
      const { hash } = this.historyService.getCurrentRouteParams();

      this.setSubmitting(true);
      HttpService.post(Endpoints.POST.NOVA_SENHA, { hash }, { body: this.form.getRecord() })
        .then(() => {
          this.panelForm.setVisible(false);
          this.panelAvisoSucesso.setVisible(true);
        })
        .catch(response => {
          ToastService.open(response);
          this.setSubmitting(false);
        });
    }
  }

  private setSubmitting(value: boolean): void {
    this.form.setState({ submitting: value });
    this.buttonConfirmar.setState({ loading: value });
  }
}
